import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api, setToken } from "../lib/api";

import { logger } from "../lib/log";
const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // Web: relies on the httpOnly cookie; native: falls back to Bearer via api.js.
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setToken(null))
      .finally(() => setReady(true));
  }, []);

  const login = useCallback(async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setToken(r.data.token); // no-op on web; kept for native
    setUser(r.data.user);
    return r.data.user;
  }, []);
  const register = useCallback(async (name, email, password) => {
    const r = await api.post("/auth/register", { name, email, password });
    setToken(r.data.token);
    setUser(r.data.user);
    return r.data.user;
  }, []);
  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      logger.warn("[auth] logout request failed", e);
    }
    setToken(null);
    setUser(null);
  }, []);

  // Memoize the context value so consumers only re-render when user/ready
  // actually change (previously a fresh object every render caused every
  // useAuth() consumer to re-render on any parent state change).
  const value = useMemo(
    () => ({ user, ready, login, register, logout }),
    [user, ready, login, register, logout]
  );

  return (
    <AuthCtx.Provider value={value}>
      {children}
    </AuthCtx.Provider>
  );
};
